import { Tab } from '../../../../../modals/product/ProductModal';

export default {
  title: 'Uusi tuote',
  tabs: {
    [Tab.General]: 'Yleiset',
    [Tab.NutritionInfo]: 'Ravintotiedot',
  },
  form: {
    categories: {
      label: 'Kategoriat',
    },
    printer: {
      label: 'Tulostin',
    },
    name: {
      label: 'Nimi',
      placeholder: 'Juustohampurilainen',
    },
    description: {
      label: 'Kuvaus',
      placeholder: '180 g naudanlihapihvi, salaatti, tomaatti, kurkku, jalapeño ja yuppi-kastike',
    },
    external_id: {
      label: '{{integration}}-viite',
      placeholder: 'esim. HubRise SKU -viite',
      read_only_hint:
        'Muokattavissa vain, kun HubRise-integraatio on yhdistetty ja valikon synkronointi on pois päältä.',
    },
    price: {
      label: 'Perushinta',
    },
    has_smart_pricing: {
      label: 'Erikoishinnat noudolle ja toimitukselle',
    },
    pickup_price: {
      label: 'Noutohinta',
      placeholder: 'Ei määritetty',
    },
    delivery_price: {
      label: 'Toimitushinta',
      placeholder: 'Ei määritetty',
    },
    image: {
      label: 'Kuva (valinnainen)',
    },
    has_combo_tax: {
      label: 'Yhdistelmävero',
    },
    is_available: {
      label: 'Varastossa',
      subtitle: 'Näkyy valikossa',
    },
    is_visible: {
      label: 'Näkyvä',
      title: 'Näkyy menussa',
      subtitle_on: 'Asiakkaat näkevät tämän tuotteen',
      subtitle_off: 'Piilotettu kaikilta asiakkailta',
    },
    is_available_for_pickup: {
      label: 'Saatavilla noutoon',
      subtitle_on: 'Asiakkaat voivat tilata noutoon',
      subtitle_off: 'Piilotettu noutomenusta',
    },
    is_available_for_delivery: {
      label: 'Saatavilla toimitukseen',
      subtitle_on: 'Asiakkaat voivat tilata toimitukseen',
      subtitle_off: 'Piilotettu toimitusmenusta',
    },
    modifiers: {
      label: 'Lisävalinnat',
    },
  },
  labels: {
    smart_pricing_update_warning:
      'Päivittämällä kaikki tämän tuotteen nykyiset älyhinnoittelusäännöt kirjoitetaan uudelleen.',
    smart_pricing_remove_warning:
      'Tallennuksen jälkeen kaikki tämän tuotteen nykyiset älyhinnoittelusäännöt poistetaan.',
  },
  availability: {
    title: 'Saatavuus',
    helper:
      'Näkyvyys on pääkytkin. Poista kanava käytöstä piilottaaksesi tuotteen nouto- tai toimitusasiakkailta poistamatta sitä menusta.',
    status: {
      both: 'Molemmat kanavat',
      pickup_only: 'Vain nouto',
      delivery_only: 'Vain toimitus',
      hidden: 'Piilotettu',
      no_channels: 'Ei kanavia',
    },
    warning: {
      no_channels: 'Tämä tuote on näkyvissä, mutta ei saatavilla missään kanavassa — asiakkaat eivät voi tilata sitä.',
    },
    placeholder: '—',
    list_badge: {
      pickup_only: 'Vain nouto',
      delivery_only: 'Vain toimitus',
      no_channels: 'Ei kanavia',
    },
  },
  buttons: {
    save: 'Tallenna',
    close: 'Sulje',
  },
  toasts: {
    changes_got_saved: 'Muutokset tallennettiin onnistuneesti!',
  },
};
